module.exports = __webpack_public_path__ + "static/media/hero.2ee2f846.jpg";